var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('h2',{staticClass:"h2--dash"},[_vm._v(" "+_vm._s(_vm.$t("web.public.googleAnalytics.title"))+" ")]),_c('formulate-input',{attrs:{"name":"google_analytics_id"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }